<template>
  <div class="qr-generator-container">
    <!-- 控制面板 -->
    <div class="control-panel">
      <!-- <div class="form-group">
        <label>二维码内容:</label>
        <input
          v-model="qrText"
          type="text"
          placeholder="输入URL或文本"
          disabled
        />
      </div> -->
      <div class="form-group">
        <label style="flex: none;">背景图片:</label>
        <input type="file" @change="handleBgImageUpload" accept="image/*" />
      </div>
      <div class="form-group">
        <label style="flex: none;">Logo图片:</label>
        <input
          type="file"
          @change="handleLogoUpload"
          accept="image/*"
          :disabled="canSelect"
        />
      </div>
      <div class="form-group">
        <div v-if="logoImage" class="logo-preview">
          <label>Logo预览:</label>
          <img
            :src="logoImage.src"
            style="max-width: 50px; max-height: 50px;"
          />
        </div>
      </div>
      <div class="form-group">
        <label>底部文字:</label>
        <textarea
          v-model="footerText"
          rows="3"
          placeholder="输入底部文字"
        ></textarea>
      </div>
      <div class="form-group">
        <label>文字颜色:</label>
        <input v-model="textColor" type="color" />
      </div>

      <div class="form-group">
        <label>文字大小:</label>
        <input v-model.number="textSize" type="range" min="12" max="50" />
        <span>{{ textSize }}px</span>
      </div>

      <div class="form-group">
        <label>二维码大小:</label>
        <input v-model.number="qrSize" type="range" min="100" max="1000" />
        <span>{{ qrSize }}px</span>
      </div>
      <div class="form-group">
        <label>二维码X位置:</label>
        <input
          v-model.number="qrPosition.x"
          type="range"
          min="0"
          :max="canvasWidth"
        />
        <span>{{ qrPosition.x }}px</span>
      </div>

      <div class="form-group">
        <label>二维码Y位置:</label>
        <input
          v-model.number="qrPosition.y"
          type="range"
          min="0"
          :max="canvasHeight"
        />
        <span>{{ qrPosition.y }}px</span>
      </div>
      <div class="form-group">
        <label>文案X位置:</label>
        <input
          v-model.number="qrPosition1.x"
          type="range"
          min="0"
          :max="canvasWidth"
        />
        <span>{{ qrPosition1.x }}px</span>
      </div>

      <div class="form-group">
        <label>文案Y位置:</label>
        <input
          v-model.number="qrPosition1.y"
          type="range"
          min="0"
          :max="canvasHeight"
        />
        <span>{{ qrPosition1.y }}px</span>
      </div>
      <div
        style="display: flex;align-items: center;justify-content:space-evenly;"
      >
        <button @click="generateAndDownload" class="generate-btn">
          生成并下载
        </button>
        <button
          @click="reset"
          class="generate-btn"
          style="background: transparent;color: black;border: 1px solid #000;box-sizing: border-box;"
        >
          重置
        </button>
      </div>
    </div>

    <!-- 预览区域 -->
    <div class="preview-area">
      <canvas
        ref="previewCanvas"
        :width="canvasWidth"
        :height="canvasHeight"
        style="max-width: 100%; height: auto;zoom: 35%"
      ></canvas>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";

export default {
  name: "CustomQRGenerator",
  data() {
    return {
      bgImage: require("../assets/imgs/codeBg.png"),
      logoImage: require("../assets/imgs/codeLogo.png"),
      textColor: "#000000",
      textSize: 12,
      qrPosition: {
        x: 210,
        y: 700
      },
      qrPosition1: {
        x: 410,
        y: 700
      },
      qrSize: 200,
      // 高清倍数 (2为Retina高清)
      qualityScale: 2,
      canvasWidth: 800,
      canvasHeight: 1700,
      link: "",
      test: "",
      timer: null,
      canSelect: true
    };
  },
  props: {
    qrText: {
      type: String,
      default: ""
    },
    footerText: {
      type: String,
      default: ""
    }
  },
  watch: {
    qrText() {
      this.generatePreview();
    },
    footerText() {
      this.generatePreview();
    },
    qrSize() {
      this.generatePreview();
    },
    textSize() {
      this.generatePreview();
    },
    textColor() {
      this.generatePreview();
    },
    qrPosition: {
      handler() {
        this.generatePreview();
      },
      deep: true
    },
    qrPosition1: {
      handler() {
        this.generatePreview();
      },
      deep: true
    }
  },
  mounted() {
    const canvas = this.$refs.previewCanvas;
    const ctx = canvas.getContext("2d");
    const qrCanvas = document.createElement("canvas");
    const background = new Image();
    background.src = this.bgImage;
    const logo1 = new Image();
    logo1.src = this.logoImage;

    background.onload = async () => {
      // 绘制背景图
      ctx.drawImage(background, 0, 0, this.canvasWidth, this.canvasHeight);
      // 2. 生成二维码（base64）
      const qrDataURL = QRCode.toCanvas(qrCanvas, this.qrText, {
        width: this.qrSize * this.qualityScale,
        margin: 2,
        color: {
          dark: "#000000",
          light: "#00000000" // 透明背景
        }
      });
      ctx.drawImage(qrCanvas, this.qrPosition.x, this.qrPosition.y);
      const qrImage = new Image();
      qrImage.src = qrDataURL;
      qrImage.onload = () => {
        // 绘制二维码
        ctx.drawImage(
          qrImage,
          this.qrPosition.x * this.qualityScale,
          this.qrPosition.y * this.qualityScale,
          this.qrSize,
          this.qrSize
        );
      };
      const logoSize = this.qrSize * this.qualityScale * 0.2;
      const logoX =
        this.qrPosition.x + (this.qrSize * this.qualityScale - logoSize) / 2;
      const logoY =
        this.qrPosition.y + (this.qrSize * this.qualityScale - logoSize) / 2;
      // 绘制Logo背景(白色圆角矩形)
      ctx.fillStyle = "#ffffff";
      ctx.beginPath();
      ctx.roundRect(logoX - 5, logoY - 5, logoSize + 10, logoSize + 10, 10);
      ctx.fill();
      // 绘制Logo

      ctx.drawImage(logo1, logoX, logoY, logoSize, logoSize);
      ctx.fillStyle = this.textColor;
      ctx.font = `bold ${this.textSize * this.qualityScale}px Arial`;
      ctx.textAlign = "center";
      ctx.textBaseline = "top";
      const lines = this.footerText.split("\n");
      const startY =
        this.qrPosition1.y +
        this.qrSize * this.qualityScale +
        30 * this.qualityScale;
      const lineHeight = this.textSize * this.qualityScale * 1.5;
      lines.forEach((line, index) => {
        ctx.fillText(line, this.qrPosition1.x, startY + index * lineHeight);
      });
    };
    this.bgImage = background;
    this.logoImage = logo1;
    this.canSelect = false;
  },
  methods: {
    reset() {
      this.textSize = 12;
      this.qrPosition.x = 210;
      this.qrPosition.y = 700;
      this.qrSize = 200;
      this.textColor = "#000000";
    },
    // 处理背景图片上传
    handleBgImageUpload(event) {
      const file = event.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = e => {
        this.bgImage = new Image();
        this.bgImage.onload = () => {
          // 调整画布尺寸匹配背景图
          this.canvasWidth = this.bgImage.width * this.qualityScale;
          this.canvasHeight = this.bgImage.height * this.qualityScale;
          this.generatePreview();
        };
        this.bgImage.src = e.target.result;
        this.canSelect = false;
      };
      reader.readAsDataURL(file);
      this.timer = setInterval(() => {
        this.generatePreview();
      }, 1000);
      setTimeout(() => {
        clearInterval(this.timer); // 清除 interval
      }, 2000);
    },

    // 处理Logo上传
    handleLogoUpload(event) {
      if (!this.bgImage) {
        this.$message({
          message: "请先上传背景图片",
          type: "warning"
        });
        this.logoImage.src = "";
        return;
      } else {
        const file = event.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = e => {
          this.logoImage = new Image();
          this.logoImage.onload = () => {
            this.generatePreview();
          };
          this.logoImage.src = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },

    // 生成预览
    async generatePreview() {
      if (!this.bgImage) return;
      const canvas = this.$refs.previewCanvas;
      const ctx = canvas.getContext("2d");
      // 清空画布
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      // 绘制背景图片 (缩放以适应高清画布)
      ctx.drawImage(
        this.bgImage,
        0,
        0,
        this.bgImage.width,
        this.bgImage.height,
        0,
        0,
        canvas.width,
        canvas.height
      );
      // 计算二维码位置 (居中)
      const qrX = (canvas.width - this.qrSize * this.qualityScale) / 2;
      const qrY = 50 * this.qualityScale; // 顶部留白

      // 生成二维码
      try {
        const qrCanvas = document.createElement("canvas");
        await QRCode.toCanvas(qrCanvas, this.qrText, {
          width: this.qrSize * this.qualityScale,
          margin: 2,
          color: {
            dark: "#000000",
            light: "#00000000" // 透明背景
          }
        });

        // 绘制二维码
        ctx.drawImage(qrCanvas, this.qrPosition.x, this.qrPosition.y);

        // 添加Logo
        if (this.logoImage) {
          const logoSize = this.qrSize * 0.2 * this.qualityScale;
          const logoX =
            this.qrPosition.x +
            (this.qrSize * this.qualityScale - logoSize) / 2;
          const logoY =
            this.qrPosition.y +
            (this.qrSize * this.qualityScale - logoSize) / 2;

          // 绘制Logo背景(白色圆角矩形)
          ctx.fillStyle = "#ffffff";
          ctx.beginPath();
          ctx.roundRect(logoX - 5, logoY - 5, logoSize + 10, logoSize + 10, 10);
          ctx.fill();
          // 绘制Logo
          ctx.drawImage(this.logoImage, logoX, logoY, logoSize, logoSize);
        }
        // 添加底部文字
        if (this.footerText) {
          ctx.fillStyle = this.textColor;
          ctx.font = `bold ${this.textSize * this.qualityScale}px Arial`;
          ctx.textAlign = "center";
          ctx.textBaseline = "top";
          const lines = this.footerText.split("\n");
          const startY =
            this.qrPosition1.y +
            this.qrSize * this.qualityScale +
            30 * this.qualityScale;
          const lineHeight = this.textSize * this.qualityScale * 1.5;

          lines.forEach((line, index) => {
            ctx.fillText(line, this.qrPosition1.x, startY + index * lineHeight);
          });
        }
      } catch (error) {
        console.error("生成二维码失败:", error);
      }
    },

    // 生成并下载最终图片
    async generateAndDownload() {
      if (!this.bgImage) {
        this.$message({
          message: "请先上传背景图片",
          type: "warning"
        });
        return;
      }
      // 创建下载用的canvas (原始尺寸，不高清)
      const downloadCanvas = document.createElement("canvas");
      const downloadCtx = downloadCanvas.getContext("2d");
      downloadCanvas.width = this.canvasWidth;
      downloadCanvas.height = this.canvasHeight;

      // 绘制背景
      downloadCtx.drawImage(
        this.bgImage,
        0,
        0,
        this.canvasWidth,
        this.canvasHeight
      );

      // 生成二维码
      try {
        const qrCanvas = document.createElement("canvas");
        await QRCode.toCanvas(qrCanvas, this.qrText, {
          width: this.qrSize * this.qualityScale,
          margin: 2,
          color: {
            dark: "#000000",
            light: "#00000000" // 透明背景
          }
        });

        // 绘制二维码
        downloadCtx.drawImage(
          qrCanvas,
          this.qrPosition.x,
          this.qrPosition.y,
          this.qrSize * this.qualityScale,
          this.qrSize * this.qualityScale
        );

        // 添加Logo
        if (this.logoImage) {
          const logoSize = this.qrSize * 0.2 * this.qualityScale;
          const logoX =
            this.qrPosition.x +
            (this.qrSize * this.qualityScale - logoSize) / 2;
          const logoY =
            this.qrPosition.y +
            (this.qrSize * this.qualityScale - logoSize) / 2;

          // 绘制Logo背景
          downloadCtx.fillStyle = "#ffffff";
          downloadCtx.beginPath();
          downloadCtx.roundRect(
            logoX - 5,
            logoY - 5,
            logoSize + 10,
            logoSize + 10,
            10
          );
          downloadCtx.fill();

          // 绘制Logo
          downloadCtx.drawImage(
            this.logoImage,
            logoX,
            logoY,
            logoSize,
            logoSize
          );
        }

        // 添加底部文字
        if (this.footerText) {
          downloadCtx.fillStyle = this.textColor;
          downloadCtx.font = `bold ${this.textSize *
            this.qualityScale}px Arial`;
          downloadCtx.textAlign = "center";
          downloadCtx.textBaseline = "top";

          const lines = this.footerText.split("\n");
          const startY =
            this.qrPosition1.y + this.qrSize * this.qualityScale + 60;
          const lineHeight = this.textSize * this.qualityScale * 1.5;

          lines.forEach((line, index) => {
            downloadCtx.fillText(
              line,
              this.qrPosition1.x,
              startY + index * lineHeight
            );
          });
        }

        // 触发下载
        const link = document.createElement("a");
        link.download = Date.now() + "邀请码.png";
        link.href = downloadCanvas.toDataURL("image/png");
        link.click();
      } catch (error) {
        console.error("生成二维码失败:", error);
        alert("生成二维码失败，请重试");
      }
    }
  }
};
</script>

<style scoped>
.qr-generator-container {
  display: flex;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  gap: 30px;
}

.control-panel {
  flex: 0 0 350px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 20px;
  background: #f5f5f5;
  border-radius: 8px;
}

.preview-area {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.form-group {
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  /* gap: 5px; */
}

.form-group label {
  font-weight: bold;
  font-size: 14px;
  width: 100px;
  text-align: left;
}

.form-group input[type="text"],
.form-group input[type="file"],
.form-group textarea {
  width: 70%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-sizing: border-box;
  margin-left: 10px;
}

.form-group textarea {
  resize: vertical;
  min-height: 80px;
}

.logo-preview {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 5px;
}

.generate-btn {
  padding: 6px 12px;
  box-sizing: border-box;
  background: #4caf50;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 10px;
}

.generate-btn:hover {
  background: #45a049;
}
</style>
